import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useProjects } from "../lib/ProjectContext";
import { api } from "../lib/apiClient";
import type { Project } from "@shared/types";

export function NewProjectPage() {
  const { refresh, selectProject } = useProjects();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [contractNumber, setContractNumber] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const data = await api.post<{ project: Project }>("/api/projects", {
        name,
        contractNumber: contractNumber || undefined,
      });
      refresh();
      selectProject(data.project.id);
      navigate("/sources");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to create project.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="content-col">
      <h2 style={{ marginTop: 0 }}>New project</h2>
      <form className="card" onSubmit={handleSubmit}>
        <div className="field">
          <label htmlFor="name">Project name</label>
          <input id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div className="field">
          <label htmlFor="contractNumber">Contract number (optional)</label>
          <input id="contractNumber" type="text" value={contractNumber} onChange={(e) => setContractNumber(e.target.value)} />
        </div>
        <button className="btn btn-primary" type="submit" disabled={submitting || !name}>
          {submitting ? "Creating…" : "Create project"}
        </button>
        {error && <p className="error-text" style={{ marginTop: "0.5rem" }}>{error}</p>}
      </form>
    </div>
  );
}
